import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';

export default {
  setData(state, data) {
    state.skills = data.skills;
    state.video = data.video;
    state.teams = data.teams;
    state.tags = data.tags;
    state.layout = data.layout;
  },

  setSkills(state, skills) {
    state.skills = skills;
  },

  setTags(state, tags) {
    state.tags = tags;
  },

  addTags(state, tags) {
    state.tags = state.tags.concat(tags);
  },

  setTagField(state, payload) {
    if (!state.currentTag) {
      Vue.set(state, 'currentTag', {});
    }
    if (payload.key === 'skillId') {
      if (!state.currentTag.id) {
        const skill = state.skills.find(item => item.id === payload.value);
        const now = state.currentTime || 0;
        const secondsBefore = skill.beforeSeconds;
        const secondsAfter = skill.laterSeconds;

        const videoEnd = new Date(state.video.end);
        const tagEnd = new Date(
          new Date(state.video.start).getTime() + 1000 * (now + secondsAfter),
        );

        const start = now - secondsBefore < 0 ? 0 : now - secondsBefore;
        const end = tagEnd > videoEnd ? state.video.duration : now + secondsAfter;
        Vue.set(state.currentTag, 'beginTime', start);
        Vue.set(state.currentTag, 'endTime', end);

        const durationStart = moment.duration(parseInt(start, 10), 'seconds');
        const formattedStart = `${durationStart
          .hours()
          .toString()
          .padStart(2, '0')}:${durationStart
          .minutes()
          .toString()
          .padStart(2, '0')}:${durationStart
          .seconds()
          .toString()
          .padStart(2, '0')}`;
        const durationEnd = moment.duration(parseInt(end, 10), 'seconds');
        const formattedEnd = `${durationEnd
          .hours()
          .toString()
          .padStart(2, '0')}:${durationEnd
          .minutes()
          .toString()
          .padStart(2, '0')}:${durationEnd
          .seconds()
          .toString()
          .padStart(2, '0')}`;

        Vue.set(state.currentTag, 'begin', formattedStart);
        Vue.set(state.currentTag, 'end', formattedEnd);
      }
    }
    if (payload.key === 'player') {
      if (!state.currentTag.players) Vue.set(state.currentTag, 'players', []);
      if (state.currentTag.players.length > 0) {
        if (
          (state.currentTag.players[0].playerId && !payload.value.playerId) ||
          (state.currentTag.players[0].opponentId && !payload.value.opponentId)
        ) {
          Vue.set(state.currentTag, 'players', []);
        }
      }
      const index = state.currentTag.players.findIndex(item =>
        item.playerId
          ? item.playerId === payload.value.playerId
          : item.opponentId === payload.value.opponentId,
      );
      if (index !== -1) {
        state.currentTag.players.splice(index, 1);
      } else {
        state.currentTag.players.push(payload.value);
      }
      let who = '';

      state.currentTag.players.forEach(player => {
        if (who !== '') {
          who += ', ';
        }
        who += player.who;
      });
      Vue.set(state.currentTag, 'who', who);
    } else {
      Vue.set(state.currentTag, payload.key, payload.value);
    }
  },

  resetTagField(state, field) {
    Vue.delete(state.currentTag, field);
  },

  setCurrentTag(state, currentTagId) {
    const tag = state.tags.find(item => item.id === currentTagId);
    if (tag) {
      Vue.set(state, 'currentTag', Object.assign({}, tag));
    }
  },

  resetCurrentTag(state) {
    Vue.set(state, 'currentTag', null);
  },

  updateCurrentTime(state, currentTime) {
    Vue.set(state, 'currentTime', currentTime);
  },

  setDuration(state, lengthInSeconds) {
    let start = new Date();
    start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const end = new Date(start.getTime() + 1000 * lengthInSeconds);
    Vue.set(state.video, 'start', start);
    Vue.set(state.video, 'end', end);
    Vue.set(state.video, 'duration', (end - start) / 1000);
  },

  updateTagDuration(state, payload) {
    if (!payload.start || !payload.end || !state.currentTag) return;

    const start = parseInt((payload.start - new Date(state.video.start)) / 1000, 10);
    const end = parseInt((payload.end - new Date(state.video.start)) / 1000, 10);

    Vue.set(state.currentTag, 'beginTime', start);
    Vue.set(state.currentTag, 'endTime', end);

    const durationStart = moment.duration(parseInt(start, 10), 'seconds');
    const formattedStart = `${durationStart
      .hours()
      .toString()
      .padStart(2, '0')}:${durationStart
      .minutes()
      .toString()
      .padStart(2, '0')}:${durationStart
      .seconds()
      .toString()
      .padStart(2, '0')}`;
    const durationEnd = moment.duration(parseInt(end, 10), 'seconds');
    const formattedEnd = `${durationEnd
      .hours()
      .toString()
      .padStart(2, '0')}:${durationEnd
      .minutes()
      .toString()
      .padStart(2, '0')}:${durationEnd
      .seconds()
      .toString()
      .padStart(2, '0')}`;

    Vue.set(state.currentTag, 'begin', formattedStart);
    Vue.set(state.currentTag, 'end', formattedEnd);
  },

  tagSaved(state, tag) {
    const index = _.findIndex(state.tags, item => item.id === tag.id);
    if (index !== -1) {
      state.tags.splice(index, 1, tag);
    } else {
      state.tags.push(tag);
    }
    state.tags.sort((a, b) => a.beginTime - b.beginTime);
    Vue.set(state, 'currentTag', null);
  },

  tagDeleted(state, tagId) {
    if (!state.tags) return;
    const index = _.findIndex(state.tags, ['id', Number(tagId)]);
    if (index !== -1) {
      Vue.delete(state.tags, index);
    }
  },

  tagDownloaded(state, tagId) {
    if (!state.tags) return;
    const index = _.findIndex(state.tags, ['id', Number(tagId)]);
    if (index !== -1) {
      Vue.set(state.tags[index], 'download', true);
    }
  },

  updateLayout(state, layout) {
    Vue.set(state, 'layout', layout);
  },

  updateVideo(state, video) {
    Vue.set(state, 'video', video);
  },

  setFullscreen(state, value) {
    Vue.set(state, 'fullscreen', value);
  },

  setEnableEdit(state, value) {
    Vue.set(state, 'enableEdit', value);
  },

  paginateVideos(state, pagination) {
    state.paginationVideos = pagination;
  },

  play(state) {
    Vue.set(state, 'playing', true);
  },

  pause(state) {
    Vue.set(state, 'playing', false);
  },

  setTutorial(state, value) {
    Vue.set(state, 'tutorial', value);
  },

  setTacticalBoard(state, value) {
    Vue.set(state, 'tacticalBoard', value);
  },

  setActiveObject(state, obj) {
    if (typeof obj === 'string') {
      state.activeObject = state.activeObject && state.activeObject === obj ? null : obj;
    } else {
      state.activeObject = state.activeObject && state.activeObject.id === obj.id ? null : obj;
    }
    if (state.canvas.drawingMode) {
      Vue.set(state.canvas, 'drawingMode', false);
    }
    if (state.canvas.wavy) {
      Vue.set(state.canvas, 'wavy', false);
    }
  },

  removeActiveObject(state) {
    state.activeObject = null;
  },

  setCanvasObjects(state, objects) {
    state.canvasObjects = objects;
  },

  setCanvasColor(state, color) {
    state.canvas.color = color;
  },

  setLineWidth(state, width) {
    if (width < 1) {
      state.canvas.lineWidth = 1;
    } else if (width > 150) {
      state.canvas.lineWidth = 150;
    } else {
      state.canvas.lineWidth = width;
    }
  },

  toggleDrawingMode(state) {
    state.canvas.drawingMode = !state.canvas.drawingMode;
    Vue.set(state.canvas, 'wavy', false);
    Vue.set(state.canvas, 'dashed', false);
  },

  removeDrawingMode(state) {
    Vue.set(state.canvas, 'drawingMode', false);
  },

  toggleWavy(state) {
    state.canvas.wavy = !state.canvas.wavy;
    Vue.set(state.canvas, 'drawingMode', false);
  },

  removeWavy(state) {
    Vue.set(state.canvas, 'wavy', false);
    Vue.set(state.canvas, 'dashed', false);
  },

  setDashed(state, value) {
    state.canvas.dashed = value;
  },

  setOpacity(state, value) {
    state.canvas.opacity = value;
  },

  export(state, json) {
    state.canvas.export = json;
  },

  exportImage(state, image) {
    state.canvas.image = image;
  },

  setCanvasSize(state, size) {
    state.canvas.width = size.width;
    state.canvas.height = size.height;
  },

  setShowTags(state, value) {
    Vue.set(state, 'showTags', value);
  },

  setShowVideo(state, value) {
    Vue.set(state, 'showVideo', value);
  },

  setShowSkills(state, value) {
    Vue.set(state, 'showSkills', value);
  },

  setShowPlayers(state, value) {
    Vue.set(state, 'showPlayers', value);
  },

  setShowTag(state, value) {
    Vue.set(state, 'showTag', value);
  },

  setShowField(state, value) {
    Vue.set(state, 'showField', value);
  },

  setShowTimeline(state, value) {
    Vue.set(state, 'showTimeline', value);
  },

  setBackgroundImage(state, value) {
    Vue.set(state, 'backgroundImage', value);
  },
  setDownloadWaiting(state, value) {
    Vue.set(state, 'downloadWaiting', value);
  },
  setSaveWaiting(state, value) {
    Vue.set(state, 'saveWaiting', value);
  },
  boardSaved(state, board) {
    const index = _.findIndex(state.tags, (item) => item.id == board.videotagId);
    if (index !== -1) {
      state.tags[index].clip = null;
      const index2 = _.findIndex(
        state.tags[index].tacticalBoards,
        (item) => item.id === board.id
      );
      if (index2 !== -1) {
        state.tags[index].tacticalBoards.splice(index2, 1, board);
      } else {
        state.tags[index].tacticalBoards.push(board);
      }
    }
  },
  boardDeleted(state, board) {
    if (!state.tags) return;
    const index = _.findIndex(state.tags, ['id', Number(board.videotagId)]);
    if (index !== -1) {
      state.tags[index].clip = null;
      const index2 = _.findIndex(
        state.tags[index].tacticalBoards,
        (item) => item.id === board.id
      );
      if (index2 !== -1) {
        Vue.delete(state.tags[index].tacticalBoards, index2);
      }
    }
  },

  setCurrentBoard(state, currentBoard) {
    const tag = state.tags.find(item => item.id === currentBoard.videotagId);
    if (tag) {
      const board = tag.tacticalBoards.find(item => item.id === currentBoard.id);
      if(board) {
        Vue.set(state, 'currentBoard', Object.assign({}, board));
        state.canvas.export = board.canvas;
      }
    }
  },

  resetCurrentBoard(state) {
    Vue.set(state, 'currentBoard', null);
    state.canvas.export = "";
    state.canvas.image = "";
  },

};



// WEBPACK FOOTER //
// ./src/store/videotags/mutations.js